import { TermSetId } from '@zg-rentals/ts-capps-client';
import type { QueryClient } from '@zg-rentals/react-query5';
import { useCappsRenterTermsAndConditionsWebApiHandler_getTermSet } from '@zg-rentals/ts-capps-client-react-query';

export const TERM_SET_TAG = 'termSet';

// Matches what the mutation cache does for meta.invalidates, for the callers that aren't a mutation
export function invalidateTermSet(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    predicate: ({ meta }) => meta?.tags?.includes(TERM_SET_TAG) ?? false,
  });
}

export function useRenterScreeningTermSet() {
  return useCappsRenterTermsAndConditionsWebApiHandler_getTermSet(
    { termSetId: TermSetId.RENTER_SCREENING },
    {
      meta: {
        tags: [TERM_SET_TAG],
        context: { api: 'cappsRenterTermsAndConditions', details: 'getTermSet' },
      },
    },
  );
}
